<ng-select #select
  id="customerZipCode"
  name="customerZipCode"
  bindLabel="name"
  bindValue="id"
  [placeholder]="'passengers.lbl_zip_insert' | translate"
  [fixedPlaceholder]="false"
  [notFoundText]="'passengers.lbl_zip_unavailable' | translate"
  [items]="zipCodes"
  (search)="searchZipCodes($event.term)"
  (clear)="clearZipCodes()"
  (change)="manageZipCodeSelection($event?.id)">
</ng-select>